import { Dispatch, SetStateAction, useState } from 'react';
import { IHsnData, IHsnDataCollection } from '../Service/hsn.service';
import { IHsnProps } from '../HsnSearch';
import { NoResultFound } from '../NoResultFound';
import { ResultMobile } from './ResultsMobile';

type IDesktopProps = IHsnProps & {
  type: keyof IHsnDataCollection;
  selectedChapterMobile: string;
  setSelectedChapterMobile: Dispatch<SetStateAction<string>>;
};

export const HsnSearchMobile = ({
  results,
  type,
  selectedChapterMobile,
  setSelectedChapterMobile,
}: IDesktopProps) => {
  const [isDropdownOpen, setDropdown] = useState<boolean>(false);
  return (
    <div className="xl:hidden lg:hidden">
      {Object.keys(results[type]).length ? (
        <div className="wg-container justify-center lg:hidden xl:hidden mt-4">
          <div
            className="border btn font-medium text-font-200 w-full flex place-content-between"
            onClick={() => setDropdown(!isDropdownOpen)}
          >
            <span className="text-s-14">
              {selectedChapterMobile == 'all'
                ? `All chapters ${Object.keys(results[type]).length}`
                : selectedChapterMobile}{' '}
            </span>
            <div>
              <svg
                width="10"
                className={`${isDropdownOpen ? 'rotate-180' : 'rotate-0'}`}
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.83712 5.5028C1.16307 5.82646 1.68939 5.82553 2.0142 5.50072L5.24336 2.27156L8.48054 5.50169C8.80529 5.82573 9.33115 5.82544 9.65554 5.50104C9.98019 5.1764 9.98019 4.65005 9.65554 4.3254L5.83262 0.502481C5.50718 0.177044 4.97954 0.177044 4.65411 0.502481L0.835034 4.32155C0.508602 4.64799 0.509537 5.17752 0.83712 5.5028Z"
                  fill="#9092A3"
                />
              </svg>
            </div>
          </div>
          {isDropdownOpen && (
            <div className="absolute wg-container left-0 z-10">
              <div className="bg-white mt-4 py-2 rounded-lg shadow-lg">
                <p
                  className="border-b-2 p-2 text-s-14"
                  onClick={() => {
                    setSelectedChapterMobile('all');
                    setDropdown(false);
                  }}
                >
                  All chapters ({Object.keys(results[type]).length})
                </p>

                {Object.keys(results[type]).map((e, index) => {
                  return (
                    <p
                      key={e + index}
                      className={`${
                        index == Object.keys(results[type]).length - 1
                          ? ''
                          : 'border-b-2'
                      } text-s-14 p-2`}
                      onClick={() => {
                        setSelectedChapterMobile(e);
                        setDropdown(false);
                      }}
                    >
                      {e}
                    </p>
                  );
                })}
              </div>
            </div>
          )}
          <div className="mt-4 pb-2 ">
            {selectedChapterMobile == 'all'
              ? Object.keys(results[type]).map((e) => {
                  const resultType = results[type][e];
                  return resultType?.map((ele: IHsnData, index: number) => (
                    <ResultMobile
                      key={index + ele.hsnCode}
                      ele={ele}
                    ></ResultMobile>
                  ));
                })
              : results[type][selectedChapterMobile]?.map(
                  (ele: IHsnData, index: number) => (
                    <ResultMobile
                      key={index + ele.hsnCode}
                      ele={ele}
                    ></ResultMobile>
                  )
                )}
          </div>
        </div>
      ) : (
        <div className="wg-container ">
          <NoResultFound
            height={'115'}
            width={'115'}
            texts={[
              'The HSN/SAC code or keyword you entered is not on record or is invalid.',
              'Please try with another HSN/SAC Code OR try changing the keywords.',
            ]}
          />
        </div>
      )}
    </div>
  );
};
